import { useEventStore } from "@/event";
import type { EventCategory } from "@/types/ui";

/**
 * Event buildings/tiles produce only while the active server event matches the tile's event kind.
 */
export function isActiveEventProductionForEntity(
	entityEventType: EventCategory | null | undefined,
): boolean {
	const { isActive, attributes } = useEventStore();
	const activeType = attributes.type;
	return !!(
		isActive &&
		activeType !== null &&
		activeType !== undefined &&
		entityEventType !== null &&
		entityEventType !== undefined &&
		activeType === entityEventType
	);
}
